import { render, staticRenderFns } from "./AttendancePDF.vue?vue&type=template&id=d37b936a&scoped=true&"
import script from "./AttendancePDF.vue?vue&type=script&lang=js&"
export * from "./AttendancePDF.vue?vue&type=script&lang=js&"
import style0 from "./AttendancePDF.vue?vue&type=style&index=0&id=d37b936a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37b936a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VChip,VDivider,VIcon,VTooltip})
